module.exports = __webpack_public_path__ + "img/oth13.350e58d2.png";